import { isSingleLineListView } from 'owa-mail-layout';

export default function getFallbackPreviewLinesToShow(): number {
    return isSingleLineListView() ? 0 : 1;
}
